export default {
  map: {
    addMarker: "Haga clic para agregar un punto",
    moveMarker: "Haga clic y arrastre para mover",
  },
  title: "Posición",
  instructions:
    "Especifique la 'Posición del Activo' y su 'Punto de Acceso' ingresando las coordenadas geográficas de cada uno o defínalas directamente en el mapa.",
  assetPosition: "Posición del Activo",
  accessPoint: "Punto de Acceso",
  latitude: "Latitud",
  longitude: "Longitud",
  zone: "Zona",
  east: "Este",
  north: "Norte",
  checkboxLabel: "Confirmar ajuste de ruta",
  checkboxDescription:
    "Por favor, marque esta casilla para confirmar que ha modificado la línea que conecta los dos puntos en el mapa para representar con precisión la ruta real desde el punto de acceso hasta el activo.",
  utmError: "Por favor, introduzca coordenadas UTM válidas",
};
